import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M28.249 23.094a.587.587 0 0 0-.72-.4l-3.813 1.09-3.267-2.177a.582.582 0 0 0-.323-.098H6.744a.582.582 0 1 0 0 1.163h13.205l3.345 2.23a.582.582 0 0 0 .482.076l4.073-1.164a.583.583 0 0 0 .4-.72Z"
    />
    <Path
      fill="#000"
      d="M24.2 16.855a2.912 2.912 0 0 0-2.909 2.909 2.913 2.913 0 0 0 2.91 2.909 2.912 2.912 0 0 0 2.908-2.91 2.912 2.912 0 0 0-2.909-2.909Zm0 4.654a1.746 1.746 0 1 1 0-3.491 1.746 1.746 0 0 1 0 3.491ZM14.893 9a2.912 2.912 0 0 0-2.909 2.91 2.912 2.912 0 0 0 2.91 2.908 2.912 2.912 0 0 0 2.909-2.909A2.912 2.912 0 0 0 14.893 9Zm0 4.655a1.746 1.746 0 1 1 0-3.492 1.746 1.746 0 0 1 0 3.492ZM18.101 18.101l-5.818-3.49a.584.584 0 0 0-.82.239l-2.327 4.654a.582.582 0 0 0 1.04.52l2.047-4.092 5.28 3.167a.582.582 0 0 0 .598-.998ZM20.127 23.836H5.582a.582.582 0 1 0 0 1.164h14.545a.582.582 0 1 0 0-1.164Z"
    />
  </Svg>
)
export default SvgComponent
